import { ReactElement } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '../../controls/Button';

/**
 * Link Sent Component for Account Activation.
 * @returns - Recat component for LinkSent UI.
 */
export default function LinkSentComponent(): ReactElement {
  const { state } = useLocation();
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-8 w-full">
      <div className="dark:bg-container-700 bg-white px-6 py-14 rounded w-full flex gap-4">
        <div className="h-12 w-12 bg-success-500 flex justify-center items-center rounded-full">
          <span className="material-icons-outlined text-white">done</span>
        </div>
        <div>
          <div className="text-xl font-semibold text-white">Activation link has been shared</div>
          <div className="mt-1 text-gray-400">An activation link has been sent to </div>
          <div className="text-gray-100">
            {state.email} <span className="cursor-pointer text-primary-500 underline">resend</span>
          </div>
          <div>
            <button
              type="button"
              onClick={() => navigate('/account-activation/device-setup')}
              className="cursor-pointer text-primary-500 underline"
            >
              Temporary activation link
            </button>
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center flex-row gap-3">
        <div className="font-medium text-gray-500">Trouble Activating?</div>
        <div className="w-40">
          <Button isBlockButton size="sm" theme="secondary-color" name="Contact Support" />
        </div>
      </div>
    </div>
  );
}
